<template>
    <div class="offcanvas offcanvas-end" tabindex="-1" id="offcanvasChat" aria-labelledby="offcanvasChatLabel"
        style="width: 420px">

        <!-- Header -->
        <div class="offcanvas-header border-bottom">
            <div class="d-flex align-items-center">
                <div class="bg-brand text-white rounded-circle d-flex align-items-center justify-content-center me-2"
                    style="width:40px;height:40px;">
                    <i class="bi bi-stars"></i>
                </div>

                <div>
                    <h5 class="mb-0" id="offcanvasChatLabel">
                        Ask Pulsar
                    </h5>
                    <small class="text-muted">
                        AI Assistant
                    </small>
                </div>
            </div>

            <button type="button" class="btn-close" data-bs-dismiss="offcanvas">
            </button>
        </div>

        <!-- Body -->
        <div class="offcanvas-body d-flex flex-column p-0">

            <!-- Messages -->
            <div class="flex-grow-1 overflow-auto p-3 bg-light" id="chatMessages" ref="chatMessages">

                <!-- AI Message -->
                <div class="d-flex mb-3">
                    <div class="bg-white border rounded-4 px-3 py-2 shadow-sm">
                        👋 Hi! I'm Pulsar. I can help you search and retrieve attendance information. Ask me about people, attendance logs, groups, dates, or other records, and I'll help you find the information you need.
                    </div>
                </div>

                <div v-for="(msg, index) in messages" :key="index">
                    <div v-if="msg.sender === 'user'" class="d-flex justify-content-end mb-3">
                        <div class="bg-brand text-white rounded-4 px-3 py-2 shadow-sm">
                            {{ msg.text }}
                        </div>
                    </div>

                    <div v-else class="d-flex mb-3">
                        <div class="bg-white border rounded-4 px-3 py-2 shadow-sm" v-html="marked(msg.text)">
                        </div>
                    </div>
                </div>

                <!-- AI Response -->
                <div class="d-flex mb-3" v-if="loading">
                    <div class="bg-white border rounded-4 px-3 py-2 shadow-sm">
                        Thinking...
                    </div>
                </div>

            </div>

            <!-- Suggested Prompts -->
            <div class="px-3 pt-2">
                <button class="btn btn-sm btn-outline-secondary rounded-pill me-1 mb-2" :disabled="loading" @click="() => { query='Recent agendas'; onSubmit() }">
                    Recent agendas
                </button>

                <button class="btn btn-sm btn-outline-secondary rounded-pill me-1 mb-2" :disabled="loading" @click="() => { query='Newcomers'; onSubmit() }">
                    Newcomers 
                </button>

                <button class="btn btn-sm btn-outline-secondary rounded-pill mb-2" :disabled="loading" @click="() => { query='Top locations'; onSubmit() }">
                    Top locations
                </button>

                <button class="btn btn-sm btn-outline-secondary rounded-pill mb-2" :disabled="loading" @click="() => { query='Top groups'; onSubmit() }">
                    Top groups
                </button>
            </div>

            <!-- Input -->
            <div class="border-top p-3">
                <form @submit.prevent="onSubmit">
                    <div class="input-group">

                        <input v-model="query" type="text" class="form-control" placeholder="Type a message..." required
                            :disabled="loading" />

                        <button class="btn btn-primary text-white" type="submit" :disabled="loading">
                            <i class="bi bi-send-fill"></i>
                        </button>
                    </div>
                </form>

                <small class="text-muted d-block mt-2">
                    Please verify important details when necessary.
                </small>
            </div>

        </div>
    </div>
</template>

<script>
import { chat } from "@/services/chat.service";
import { marked } from 'marked';
export default {
    data() {
        return {
            loading: false,
            query: "",
            messages: []
        };
    },
    methods: {
        scrollToBottom() {
            const container = this.$refs.chatMessages;
            if (container) {
                container.scrollTop = container.scrollHeight;
            }
        },
        onSubmit() {
            this.loading = true;

            this.messages.push({ sender: 'user', text: this.query });
            this.$nextTick(this.scrollToBottom);

            chat(this.query).then(r => {
                this.messages.push({ sender: 'bot', text: r.data });
                this.query = "";
                this.$nextTick(this.scrollToBottom);
                this.loading = false;
            }, err => {
                this.messages.push({ sender: 'bot', text: "Sorry, I couldn't process your request. Please try again later." });
                this.$nextTick(this.scrollToBottom);
                this.loading = false;
            });
        },
        marked(val) {
            return marked(val);
        }
    }
}
</script>

<style scoped>
.bg-brand {
    background-color: var(--primary-color);
    color: #fff;
}
</style>